import {
    FETCH_POINTS_OF_INTEREST,
    FETCH_POINTS_OF_INTEREST_FAILURE,
    FETCH_POINTS_OF_INTEREST_SUCCESS,

    FETCH_POINT_OF_INTEREST,
    FETCH_POINT_OF_INTEREST_FAILURE,
    FETCH_POINT_OF_INTEREST_SUCCESS,

    FETCH_POINT_OF_INTEREST_LOCALISATION,
    FETCH_POINT_OF_INTEREST_LOCALISATION_FAILURE,
    FETCH_POINT_OF_INTEREST_LOCALISATION_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

export const fetchPointsOfInterest = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 12,
        sort_by: payload.field ? payload.field : 'id',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_POINTS_OF_INTEREST,
        payload: params,
    };
};

export const fetchPointsOfInterestFailure = (error) => {
    return {
        type: FETCH_POINTS_OF_INTEREST_FAILURE,
        error: error,
    };
};

export const fetchPointsOfInterestSuccess = (payload) => {
    return {
        type: FETCH_POINTS_OF_INTEREST_SUCCESS,
        payload: payload,
    };
};

export const fetchPointOfInterest = (payload) => {
    return {
        type: FETCH_POINT_OF_INTEREST,
        payload: payload,
    };
};

export const fetchPointOfInterestFailure = (error) => {
    return {
        type: FETCH_POINT_OF_INTEREST_FAILURE,
        error: error,
    };
};

export const fetchPointOfInterestSuccess = (response) => {
    return {
        type: FETCH_POINT_OF_INTEREST_SUCCESS,
        response: response,
    };
};

export const fetchPointOfInterestLocalisation = (payload) => {
    return {
        type: FETCH_POINT_OF_INTEREST_LOCALISATION,
        payload: payload,
    };
};

export const fetchPointOfInterestLocalisationFailure = (error) => {
    return {
        type: FETCH_POINT_OF_INTEREST_LOCALISATION_FAILURE,
        error: error,
    };
};

export const fetchPointOfInterestLocalisationSuccess = (payload, response) => {
    return {
        type: FETCH_POINT_OF_INTEREST_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/pointsofinterest/fetchPointsOfInterest.js